import IApiResponse from "../interfaces/IApiResponse";
import IBibleSettings from "../interfaces/IBibleSettings";
import BibleSettingsServiceHybrid from "./hybrid/BibleSettingsServiceHybrid";
import BibleSettingsServiceWeb from "./web/BibleSettingsServiceWeb";
import { isPlatform } from "@ionic/react";

export interface IBibleSettingsService {
    createBibleSettings: (bibleSettings: IBibleSettings) => Promise<IApiResponse<IBibleSettings>>,
    getBibleSettings: () =>  Promise<IApiResponse<IBibleSettings>>,
    updateBibleSettings: (bibleSettings: IBibleSettings) => Promise<IApiResponse<IBibleSettings>>,
}

const BibleSettingsService: IBibleSettingsService = {
    
    createBibleSettings: (bibleSettings) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - createBibleSettings')
            return BibleSettingsServiceHybrid.createBibleSettings(bibleSettings);
        } else {
            console.log('WEB - createBibleSettings')
            return BibleSettingsServiceWeb.createBibleSettings(bibleSettings);
        }
    },
    getBibleSettings: () =>  {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - getBibleSettings')
            return BibleSettingsServiceHybrid.getBibleSettings();
        } else {
            console.log('WEB - getBibleSettings')
            return BibleSettingsServiceWeb.getBibleSettings();
        }
    },
    updateBibleSettings: (bibleSettings) => {
        if (isPlatform('hybrid')) {
            console.log('HYBRID - updateBibleSettings')
            return BibleSettingsServiceHybrid.updateBibleSettings(bibleSettings);
        } else {
            console.log('WEB - updateBibleSettings')
            return BibleSettingsServiceWeb.updateBibleSettings(bibleSettings);
        }
    },
}

export default BibleSettingsService;